/* ==========================================================================
   MARNESS LP — Cinematic Blur Fade-in + Slide — v3ベース + v4追加統合版
   ========================================================================== */

(function () {
  "use strict";

  gsap.registerPlugin(ScrollTrigger);

  var isMobile = window.innerWidth <= 768;

  var DURATION = 1.8;
  var TEXT_DURATION = 1.5;
  var EASE = "power2.out";
  var BLUR = "12px";
  var SLIDE_X = isMobile ? 0 : 60;
  var SLIDE_Y = isMobile ? 30 : 60;

  /* ==========================================================================
     FV テキスト
     ========================================================================== */
  var fvJp = document.querySelector(".fv-title-jp");
  var fvEn = document.querySelector(".fv-title-en");
  if (fvJp) {
    gsap.set(fvJp, { opacity: 0, y: 30, filter: "blur(10px)" });
    gsap.to(fvJp, { opacity: 1, y: 0, filter: "blur(0px)", duration: 2.0, ease: EASE, delay: 0.6 });
  }
  if (fvEn) {
    gsap.set(fvEn, { opacity: 0, y: 20, filter: "blur(10px)" });
    gsap.to(fvEn, { opacity: 1, y: 0, filter: "blur(0px)", duration: 2.0, ease: EASE, delay: 1.2 });
  }

  /* ==========================================================================
     モバイル
     ========================================================================== */
  if (isMobile) {

    // v4準拠で安全に動作するよう delay 引数も維持
    function observeAndAnimate(el, fromVars, toVars, delay) {
      if (!el) return;
      gsap.set(el, fromVars);
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.unobserve(el);
            if (delay) toVars.delay = delay;
            gsap.to(el, toVars);
          }
        });
      }, { threshold: 0.1 });
      observer.observe(el);
    }

    function observeTimeline(trigger, animations) {
      if (!trigger) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.unobserve(trigger);
            var tl = gsap.timeline();
            animations.forEach(function (a) {
              if (a.el) {
                gsap.set(a.el, a.from);
                tl.to(a.el, a.to, a.position || "+=0");
              }
            });
          }
        });
      }, { threshold: 0.05 });
      observer.observe(trigger);
    }

    /* --- gallery-row 系 --- */
    var heading = document.querySelector(".gallery-heading");
    observeAndAnimate(heading,
      { opacity: 0, y: 20, filter: "blur(8px)" },
      { opacity: 1, y: 0, filter: "blur(0px)", duration: 1.4, ease: EASE }
    );
    [".gallery-row-1", ".gallery-row-2", ".gallery-row-3"].forEach(function (sel) {
      var row = document.querySelector(sel);
      if (!row) return;
      observeTimeline(row, [
        { el: row.querySelector(".gallery-img"),
          from: { opacity: 0, y: SLIDE_Y, filter: "blur(" + BLUR + ")" },
          to: { opacity: 1, y: 0, filter: "blur(0px)", duration: DURATION, ease: EASE } },
        { el: row.querySelector(".gallery-vertical-text"),
          from: { opacity: 0, y: SLIDE_Y, filter: "blur(" + BLUR + ")" },
          to: { opacity: 1, y: 0, filter: "blur(0px)", duration: TEXT_DURATION, ease: EASE },
          position: "-=1.0" },
      ]);
    });
    var row4 = document.querySelector(".gallery-row-4");
    if (row4) {
      observeAndAnimate(row4.querySelector(".gallery-img"),
        { opacity: 0, scale: 0.97, filter: "blur(" + BLUR + ")" },
        { opacity: 1, scale: 1, filter: "blur(0px)", duration: 2.0, ease: EASE }
      );
    }

    /* ===================== Cine Gallery 内処理 ===================== */

    /* ① Hero */
    var heroRow = document.querySelector(".cine-row-hero");
    if (heroRow) {
      observeTimeline(heroRow, [
        { el: heroRow.querySelector(".cine-more-beauty"),
          from: { opacity: 0, x: -20, filter: "blur(10px)" },
          to: { opacity: 1, x: 0, filter: "blur(0px)", duration: 2.0, ease: EASE } },
        { el: heroRow.querySelector(".cine-hero-img"),
          from: { opacity: 0, y: 40, filter: "blur(" + BLUR + ")" },
          to: { opacity: 1, y: 0, filter: "blur(0px)", duration: DURATION, ease: EASE },
          position: "-=1.6" },
      ]);
    }

    /* テキストボックス */
    var heroTB = document.querySelector(".cine-hero-textbox");
    if (heroTB) {
      observeAndAnimate(heroTB,
        { opacity: 0, y: 20, filter: "blur(8px)" },
        { opacity: 1, y: 0, filter: "blur(0px)", duration: TEXT_DURATION, ease: EASE }
      );
    }

    /* ② Offset */
    var offsetRow = document.querySelector(".cine-row-offset");
    if (offsetRow) {
      observeTimeline(offsetRow, [
        { el: offsetRow.querySelector(".cine-offset-img"),
          from: { opacity: 0, y: SLIDE_Y, filter: "blur(" + BLUR + ")" },
          to: { opacity: 1, y: 0, filter: "blur(0px)", duration: DURATION, ease: EASE } },
        { el: offsetRow.querySelector(".cine-offset-text"),
          from: { opacity: 0, y: 20, filter: "blur(8px)" },
          to: { opacity: 1, y: 0, filter: "blur(0px)", duration: TEXT_DURATION, ease: EASE },
          position: "-=0.8" },
      ]);
    }

    /* ③ デコバー */
    var decoBar = document.querySelector(".cine-deco-bar");
    observeAndAnimate(decoBar,
      { opacity: 0, scaleX: 0 },
      { opacity: 1, scaleX: 1, duration: 1.4, ease: EASE }
    );

    /* ④ Pair (v3) */
    var pair = document.querySelector(".cine-pair");
    if (pair) {
      var pairItems = pair.querySelectorAll(".cine-pair-item");
      var pAnims = [];
      if (pairItems[0]) pAnims.push({ el: pairItems[0],
        from: { opacity: 0, y: SLIDE_Y, filter: "blur(" + BLUR + ")" },
        to: { opacity: 1, y: 0, filter: "blur(0px)", duration: DURATION, ease: EASE } });
      if (pairItems[1]) pAnims.push({ el: pairItems[1],
        from: { opacity: 0, y: SLIDE_Y, filter: "blur(" + BLUR + ")" },
        to: { opacity: 1, y: 0, filter: "blur(0px)", duration: DURATION, ease: EASE },
        position: "-=1.4" });
      observeTimeline(pair, pAnims);
    }

    /* [★v4追加] ④ rose_3 back (モバイル) */
    var backRow = document.querySelector(".cine-row-back");
    if (backRow) {
      observeTimeline(backRow, [
        { el: backRow.querySelector(".cine-back-img"),
          from: { opacity: 0, y: SLIDE_Y, filter: "blur(" + BLUR + ")" },
          to: { opacity: 1, y: 0, filter: "blur(0px)", duration: DURATION, ease: EASE } },
        { el: backRow.querySelector(".cine-back-text-tr"),
          from: { opacity: 0, y: -10, filter: "blur(6px)" },
          to: { opacity: 1, y: 0, filter: "blur(0px)", duration: 1.2, ease: EASE },
          position: "-=1.0" },
        { el: backRow.querySelector(".cine-back-text-bl"),
          from: { opacity: 0, y: 20, filter: "blur(8px)" },
          to: { opacity: 1, y: 0, filter: "blur(0px)", duration: TEXT_DURATION, ease: EASE },
          position: "-=0.8" },
      ]);
    }

    /* rose_6 テキストボックス (v3) */
    var r6box = document.querySelector(".cine-rose6-box");
    observeAndAnimate(r6box,
      { opacity: 0, y: 15, filter: "blur(6px)" },
      { opacity: 1, y: 0, filter: "blur(0px)", duration: 1.2, ease: EASE }
    );

    /* ⑤ Single (v3) */
    var single = document.querySelector(".cine-single");
    if (single) {
      observeAndAnimate(single,
        { opacity: 0, scale: 0.97, filter: "blur(" + BLUR + ")" },
        { opacity: 1, scale: 1, filter: "blur(0px)", duration: 2.0, ease: EASE }
      );
    }

    /* ⑥ Closing */
    var closing = document.querySelector(".cine-closing");
    if (closing) {
      observeTimeline(closing, [
        { el: closing,
          from: { opacity: 0, y: SLIDE_Y, filter: "blur(" + BLUR + ")" },
          to: { opacity: 1, y: 0, filter: "blur(0px)", duration: DURATION, ease: EASE } },
        { el: closing.querySelector(".cine-closing-text"),
          from: { opacity: 0, y: 20, filter: "blur(8px)" },
          to: { opacity: 1, y: 0, filter: "blur(0px)", duration: TEXT_DURATION, ease: EASE },
          position: "-=0.8" },
      ]);
    }

    /* About */
    var aboutSection = document.querySelector(".about-section");
    if (aboutSection) {
      observeTimeline(aboutSection, [
        { el: document.querySelector(".about-main-title"),
          from: { opacity: 0, y: 30, filter: "blur(10px)" },
          to: { opacity: 1, y: 0, filter: "blur(0px)", duration: 2.0, ease: EASE } },
        { el: document.querySelector(".about-sub-title"),
          from: { opacity: 0, y: 20, filter: "blur(10px)" },
          to: { opacity: 1, y: 0, filter: "blur(0px)", duration: 1.8, ease: EASE },
          position: "-=1.2" },
        { el: document.querySelector(".about-lead-body"),
          from: { opacity: 0, y: 20, filter: "blur(8px)" },
          to: { opacity: 1, y: 0, filter: "blur(0px)", duration: 1.8, ease: EASE },
          position: "-=1.0" },
        { el: document.querySelector(".about-brand-logo"),
          from: { opacity: 0, filter: "blur(8px)" },
          to: { opacity: 1, filter: "blur(0px)", duration: 1.5, ease: EASE },
          position: "-=0.8" },
      ]);
    }

  /* ==========================================================================
     PC: ScrollTrigger
     ========================================================================== */
  } else {

    var pcScroller = document.getElementById("centerScroll") || window;
    ScrollTrigger.defaults({ scroller: pcScroller });
    var TRIGGER_START = "top 55%";

    /* --- gallery-row 系 --- */
    var heading = document.querySelector(".gallery-heading");
    if (heading) {
      gsap.set(heading, { opacity: 0, y: 20, filter: "blur(8px)" });
      gsap.to(heading, { opacity: 1, y: 0, filter: "blur(0px)", duration: 1.4, ease: EASE,
        scrollTrigger: { trigger: heading, start: TRIGGER_START } });
    }
    var row1 = document.querySelector(".gallery-row-1");
    if (row1) {
      var r1I = row1.querySelector(".gallery-img"), r1T = row1.querySelector(".gallery-vertical-text");
      if (r1I) gsap.set(r1I, { opacity: 0, y: 60, filter: "blur(" + BLUR + ")" });
      if (r1T) gsap.set(r1T, { opacity: 0, x: -60, filter: "blur(" + BLUR + ")" });
      var tl1 = gsap.timeline({ scrollTrigger: { trigger: row1, start: TRIGGER_START } });
      if (r1I) tl1.to(r1I, { opacity: 1, y: 0, filter: "blur(0px)", duration: DURATION, ease: EASE });
      if (r1T) tl1.to(r1T, { opacity: 1, x: 0, filter: "blur(0px)", duration: TEXT_DURATION, ease: EASE }, "-=1.0");
    }
    var row2 = document.querySelector(".gallery-row-2");
    if (row2) {
      var r2I = row2.querySelector(".gallery-img"), r2T = row2.querySelector(".gallery-vertical-text");
      if (r2I) gsap.set(r2I, { opacity: 0, x: -60, filter: "blur(" + BLUR + ")" });
      if (r2T) gsap.set(r2T, { opacity: 0, x: 60, filter: "blur(" + BLUR + ")" });
      var tl2 = gsap.timeline({ scrollTrigger: { trigger: row2, start: TRIGGER_START } });
      if (r2I) tl2.to(r2I, { opacity: 1, x: 0, filter: "blur(0px)", duration: DURATION, ease: EASE });
      if (r2T) tl2.to(r2T, { opacity: 1, x: 0, filter: "blur(0px)", duration: TEXT_DURATION, ease: EASE }, "-=1.0");
    }
    var row3 = document.querySelector(".gallery-row-3");
    if (row3) {
      var r3I = row3.querySelector(".gallery-img"), r3T = row3.querySelector(".gallery-vertical-text");
      if (r3I) gsap.set(r3I, { opacity: 0, y: -60, filter: "blur(" + BLUR + ")" });
      if (r3T) gsap.set(r3T, { opacity: 0, x: -60, filter: "blur(" + BLUR + ")" });
      var tl3 = gsap.timeline({ scrollTrigger: { trigger: row3, start: TRIGGER_START } });
      if (r3I) tl3.to(r3I, { opacity: 1, y: 0, filter: "blur(0px)", duration: DURATION, ease: EASE });
      if (r3T) tl3.to(r3T, { opacity: 1, x: 0, filter: "blur(0px)", duration: TEXT_DURATION, ease: EASE }, "-=1.0");
    }
    var row4 = document.querySelector(".gallery-row-4");
    if (row4 && row4.querySelector(".gallery-img")) {
      var r4I = row4.querySelector(".gallery-img");
      gsap.set(r4I, { opacity: 0, scale: 0.97, filter: "blur(" + BLUR + ")" });
      gsap.to(r4I, { opacity: 1, scale: 1, filter: "blur(0px)", duration: 2.0, ease: EASE,
        scrollTrigger: { trigger: row4, start: TRIGGER_START } });
    }

    /* ===================== Cine Gallery (PC) ===================== */

    /* ① Hero */
    var heroRow = document.querySelector(".cine-row-hero");
    if (heroRow) {
      var mb = heroRow.querySelector(".cine-more-beauty");
      var hi = heroRow.querySelector(".cine-hero-img");
      if (mb) gsap.set(mb, { opacity: 0, x: -30, filter: "blur(10px)" });
      if (hi) gsap.set(hi, { opacity: 0, y: 60, filter: "blur(" + BLUR + ")" });
      var tlH = gsap.timeline({ scrollTrigger: { trigger: heroRow, start: TRIGGER_START } });
      if (mb) tlH.to(mb, { opacity: 1, x: 0, filter: "blur(0px)", duration: 2.0, ease: EASE }, 0);
      if (hi) tlH.to(hi, { opacity: 1, y: 0, filter: "blur(0px)", duration: DURATION, ease: EASE }, 0.2);
    }

    /* テキストボックス */
    var heroTB = document.querySelector(".cine-hero-textbox");
    if (heroTB) {
      gsap.set(heroTB, { opacity: 0, y: 20, filter: "blur(8px)" });
      gsap.to(heroTB, { opacity: 1, y: 0, filter: "blur(0px)", duration: TEXT_DURATION, ease: EASE,
        scrollTrigger: { trigger: heroTB, start: "top 70%" } });
    }

    /* ② Offset */
    var offsetRow = document.querySelector(".cine-row-offset");
    if (offsetRow) {
      var oi = offsetRow.querySelector(".cine-offset-img");
      var ot = offsetRow.querySelector(".cine-offset-text");
      if (oi) gsap.set(oi, { opacity: 0, x: -60, filter: "blur(" + BLUR + ")" });
      if (ot) gsap.set(ot, { opacity: 0, y: 20, filter: "blur(8px)" });
      var tlO = gsap.timeline({ scrollTrigger: { trigger: offsetRow, start: TRIGGER_START } });
      if (oi) tlO.to(oi, { opacity: 1, x: 0, filter: "blur(0px)", duration: DURATION, ease: EASE });
      if (ot) tlO.to(ot, { opacity: 1, y: 0, filter: "blur(0px)", duration: TEXT_DURATION, ease: EASE }, "-=0.8");
    }

    /* ③ Deco */
    var decoBar = document.querySelector(".cine-deco-bar");
    if (decoBar) {
      gsap.set(decoBar, { opacity: 0, scaleX: 0 });
      gsap.to(decoBar, { opacity: 1, scaleX: 1, duration: 1.4, ease: EASE,
        scrollTrigger: { trigger: decoBar, start: "top 70%" } });
    }

    /* ④ Pair (v3) */
    var pair = document.querySelector(".cine-pair");
    if (pair) {
      var pI = pair.querySelectorAll(".cine-pair-item");
      if (pI[0]) gsap.set(pI[0], { opacity: 0, x: -60, filter: "blur(" + BLUR + ")" });
      if (pI[1]) gsap.set(pI[1], { opacity: 0, x: 60, filter: "blur(" + BLUR + ")" });
      var tlP = gsap.timeline({ scrollTrigger: { trigger: pair, start: TRIGGER_START } });
      if (pI[0]) tlP.to(pI[0], { opacity: 1, x: 0, filter: "blur(0px)", duration: DURATION, ease: EASE }, 0);
      if (pI[1]) tlP.to(pI[1], { opacity: 1, x: 0, filter: "blur(0px)", duration: DURATION, ease: EASE }, 0.2);
    }

    /* [★v4追加] ④ rose_3 back (PC版: ScrollTrigger) */
    var backRow = document.querySelector(".cine-row-back");
    if (backRow) {
      var bi = backRow.querySelector(".cine-back-img");
      var btr = backRow.querySelector(".cine-back-text-tr");
      var bbl = backRow.querySelector(".cine-back-text-bl");
      if (bi) gsap.set(bi, { opacity: 0, x: 60, filter: "blur(" + BLUR + ")" });
      if (btr) gsap.set(btr, { opacity: 0, y: -10, filter: "blur(6px)" });
      if (bbl) gsap.set(bbl, { opacity: 0, y: 20, filter: "blur(8px)" });
      var tlB = gsap.timeline({ scrollTrigger: { trigger: backRow, start: TRIGGER_START } });
      if (bi) tlB.to(bi, { opacity: 1, x: 0, filter: "blur(0px)", duration: DURATION, ease: EASE });
      if (btr) tlB.to(btr, { opacity: 1, y: 0, filter: "blur(0px)", duration: 1.2, ease: EASE }, "-=1.0");
      if (bbl) tlB.to(bbl, { opacity: 1, y: 0, filter: "blur(0px)", duration: TEXT_DURATION, ease: EASE }, "-=0.8");
    }

    /* rose_6 テキストボックス (v3) */
    var r6box = document.querySelector(".cine-rose6-box");
    if (r6box) {
      gsap.set(r6box, { opacity: 0, y: 15, filter: "blur(6px)" });
      gsap.to(r6box, { opacity: 1, y: 0, filter: "blur(0px)", duration: 1.2, ease: EASE,
        scrollTrigger: { trigger: r6box, start: "top 70%" } });
    }

    /* ⑤ Single (v3) */
    var single = document.querySelector(".cine-single");
    if (single) {
      gsap.set(single, { opacity: 0, scale: 0.97, filter: "blur(" + BLUR + ")" });
      gsap.to(single, { opacity: 1, scale: 1, filter: "blur(0px)", duration: 2.0, ease: EASE,
        scrollTrigger: { trigger: single, start: TRIGGER_START } });
    }

    /* ⑥ Closing */
    var closing = document.querySelector(".cine-closing");
    if (closing) {
      var ct = closing.querySelector(".cine-closing-text");
      gsap.set(closing, { opacity: 0, y: 60, filter: "blur(" + BLUR + ")" });
      if (ct) gsap.set(ct, { opacity: 0, y: 20, filter: "blur(8px)" });
      var tlC = gsap.timeline({ scrollTrigger: { trigger: closing, start: TRIGGER_START } });
      tlC.to(closing, { opacity: 1, y: 0, filter: "blur(0px)", duration: DURATION, ease: EASE });
      if (ct) tlC.to(ct, { opacity: 1, y: 0, filter: "blur(0px)", duration: TEXT_DURATION, ease: EASE }, "-=0.8");
    }

    /* About */
    var aT = document.querySelector(".about-main-title");
    var aS = document.querySelector(".about-sub-title");
    var aB = document.querySelector(".about-lead-body");
    var aL = document.querySelector(".about-brand-logo");
    if (aT) gsap.set(aT, { opacity: 0, y: 30, filter: "blur(10px)" });
    if (aS) gsap.set(aS, { opacity: 0, y: 20, filter: "blur(10px)" });
    if (aB) gsap.set(aB, { opacity: 0, y: 20, filter: "blur(8px)" });
    if (aL) gsap.set(aL, { opacity: 0, filter: "blur(8px)" });
    var aSec = document.querySelector(".about-section");
    if (aSec) {
      var tlA = gsap.timeline({ scrollTrigger: { trigger: aSec, start: TRIGGER_START } });
      if (aT) tlA.to(aT, { opacity: 1, y: 0, filter: "blur(0px)", duration: 2.0, ease: EASE });
      if (aS) tlA.to(aS, { opacity: 1, y: 0, filter: "blur(0px)", duration: 1.8, ease: EASE }, "-=1.2");
      if (aB) tlA.to(aB, { opacity: 1, y: 0, filter: "blur(0px)", duration: 1.8, ease: EASE }, "-=1.0");
      if (aL) tlA.to(aL, { opacity: 1, filter: "blur(0px)", duration: 1.5, ease: EASE }, "-=0.8");
    }

    var resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { ScrollTrigger.refresh(); }, 250);
    });

  }

})();